import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DownloadButton from "../DownloadButton";
import { strings } from "../../utils/constants";
import { useTranslation } from "react-i18next";
import { fetchAppInfo } from "../../redux/Actions";

const DownloadDesktopApp = ({ os, onOpenApp }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { appInfoResponse, isLoading } = useSelector(
    (state) => state.appInfoReducer
  );
  const { language } = useSelector((state) => state.generalReducer);

  const getAppinfo = async () => {
    dispatch(fetchAppInfo({ language: language }));
  };

  useEffect(() => {
    getAppinfo();
  }, []);

  // Show loading spinner while data is being fetched
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <CircularProgress color={"success"} size={50} />
      </div>
    );
  }

  // Get app info
  const appInfo = appInfoResponse?.data?.data;
  const version =
    os === "WindowsOS" ? appInfo?.windows_version : appInfo?.mac_version;
  const downloadUrl =
    os === "WindowsOS" ? appInfo?.windows_app_url : appInfo?.mac_app_url;
  const oldVersion = appInfoResponse?.data?.old_version; // Check if the version is old

  return (
    <section className="py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            {os === "WindowsOS" || os === "MacOS" ? (
              <>
                {oldVersion && (
                  <div className="alert alert-warning" role="alert">
                    <strong>{t(strings.words.NOTE)}:</strong>{" "}
                    {t(strings.translate.UPDATE_APP_NOTE)}
                  </div>
                )}
                <h2 className="font-weight-bold my-4">
                  {oldVersion
                    ? t(strings.words.UPDATE)
                    : t(strings.words.DOWNLOAD)}{" "}
                  {os === "WindowsOS"
                    ? t(strings.words.WINDOWS)
                    : t(strings.words.MAC)}{" "}
                  {t(strings.words.APP)} {version && <span>(v {version})</span>}
                </h2>
                <p className="lead mb-4">
                  {t(strings.translate.DOWNLOAD_APP_TXT_PART1)}
                  <span className="text-lowercase">
                    {oldVersion
                      ? t(strings.words.UPDATE)
                      : t(strings.words.DOWNLOAD)}
                  </span>{" "}
                  {t(strings.translate.DOWNLOAD_APP_TXT_PART2)}
                  {os === "WindowsOS"
                    ? t(strings.words.WINDOWS)
                    : t(strings.words.MAC)}
                  .
                </p>
                {downloadUrl && (
                  <DownloadButton link={downloadUrl} oldVersion={oldVersion} os={os} />
                )}

                {/* Already installed? Launch the app via the website so the
                    source/language are forwarded through the formdepot:// deep
                    link (same path as the "Load Desktop Application" button). */}
                {onOpenApp && (
                  <div className="mt-4">
                    <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
                      {t(strings.translate.ALREADY_INSTALLED_PROMPT)}
                    </p>
                    <button
                      type="button"
                      className="btn btn--outline-primary d-inline-flex align-items-center justify-content-center px-4 py-2"
                      onClick={onOpenApp}
                      style={{ minWidth: "200px" }}
                    >
                      {t(strings.translate.OPEN_APPLICATION)}
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div>
                <p className="lead mb-4">
                  <i className="fa fa-info-circle me-2" aria-hidden="true"></i>
                  {t(strings.translate.INSTALL_ONLY_ON_WINDOWS_OR_MAC)}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadDesktopApp;
